type RuleValue =
  | string
  | number
  | boolean
  | RegExp
  | { value: number; message: string }
  | undefined

export type ValidationRulesInput = {
  required?: boolean
  min?: number
  max?: number
  minLength?: number
  maxLength?: number
  pattern?: RegExp | string
}

const messages = {
  required: () => 'Campo obrigatório',
  min: (min: number) => ({ value: min, message: `Valor deve ser no mínimo ${min}` }),
  max: (max: number) => ({ value: max, message: `Valor deve ser no máximo ${max}` }),
  minLength: (minLength: number) => ({
    value: minLength,
    message: `Campo deve ter pelo menos ${minLength} caracteres`
  }),
  maxLength: (maxLength: number) => ({
    value: maxLength,
    message: `Campo deve ter no máximo ${maxLength} caracteres`
  }),
  pattern: () => ''
}

export const getRules = ({
  required,
  min,
  max,
  minLength,
  maxLength,
  pattern
}: ValidationRulesInput = {}): Record<string, RuleValue> => ({
  required: required ? messages.required() : required,
  min: min ? messages.min(min) : min,
  max: max ? messages.max(max) : max,
  minLength: minLength ? messages.minLength(minLength) : minLength,
  maxLength: maxLength ? messages.maxLength(maxLength) : maxLength,
  pattern: pattern ? messages.pattern() : pattern
})

export default getRules
